<!-- ARIA Completed -->
<div class="bg-secondary text-body" data-bs-theme="dark" style="--bs-body-bg: var(--bs-secondary);">
  <div class="container-fluid container-lg">
    <div class="d-flex align-items-center justify-content-between gap-4 py-2 py-lg-3" role="toolbar">
      <!-- - - - Social Media & Contact - - - -->
      <div class="d-none d-lg-flex align-items-center gap-4">
        <a href="https://www.facebook.com/hakikatev" rel="noopener noreferrer" target="_blank" aria-label="Facebook Sayfası" i18n-aria-label>
          <fa-icon [icon]="iconFacebook" aria-hidden="true" />
        </a>
        <a href="https://www.instagram.com/hakikatev" rel="noopener noreferrer" target="_blank" aria-label="Instagram Sayfası" i18n-aria-label>
          <fa-icon [icon]="iconInstagram" aria-hidden="true" />
        </a>
        <a href="https://www.tiktok.com/@hakikatev" rel="noopener noreferrer" target="_blank" aria-label="TikTok Sayfası" i18n-aria-label>
          <fa-icon [icon]="iconTiktok" aria-hidden="true" />
        </a>
        <span class="text-body opacity-50" aria-hidden="true">|</span>
        <a class="icon-link gap-2 link-body-emphasis text-decoration-none" href="tel:+4961057176116" type="phone" aria-label="İletişim Telefon Numarası +49 6105 717 6116" i18n-aria-label>
          <fa-icon [icon]="iconPhone" size="sm" />
          <small>+49 6105 - 717 6116</small>
        </a>
      </div>

      <!-- - - - Localization & Authentication - - - -->
      <div class="d-flex flex-grow-1 flex-lg-grow-0 align-items-center justify-content-between gap-4" aria-label="Dil ve Kimlik İşlemleri" role="group">
        <app-localize />
        <span class="d-none d-lg-block opacity-50 text-body" aria-hidden="true" role="separator">|</span>
        <app-auth />
      </div>
    </div>
  </div>
</div>